export * from './MedicalHoCategoryIcon';
